var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIconTrimmed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFF",
    strokeWidth: 0.902,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.133,
    height: 12.122,
    rx: 1.425
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7244998,0.422749995 L10.6494999,7.5904999 C10.1085686,8.07432351 9.29043113,8.07432351 8.74949989,7.5904999 L0.541499993,0.275499997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08699991 6.10374992L0.517749994 11.5614999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5677498 11.4522499L12.1694998 6.15599992"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconTrimmed);
export default __webpack_public_path__ + "static/media/mail-icon-trimmed.30e390c6f24ef2abc9e68a3601981d56.svg";
export { ForwardRef as ReactComponent };